/**
 * IMAYO Journal Blog - SP category dropdown navigation, SERIES slider (Splide)
 */
(function () {
  'use strict';

  var DROPDOWN_SELECTOR = '.js-category-dropdown';
  var SERIES_SLIDER_SELECTOR = '.js-series-slider';
  var SERIES_PREV_SELECTOR = '.js-series-prev';
  var SERIES_NEXT_SELECTOR = '.js-series-next';

  function init() {
    initCategoryDropdown();
    initSeriesSlider();
  }

  function initCategoryDropdown() {
    var dropdown = document.querySelector(DROPDOWN_SELECTOR);
    if (!dropdown) return;

    dropdown.addEventListener('change', function () {
      location.href = dropdown.value;
    });
  }

  function initSeriesSlider() {
    var sliderRoot = document.querySelector(SERIES_SLIDER_SELECTOR);
    if (!sliderRoot) return;

    var slider = new Splide(sliderRoot, {
      type: 'slide',
      arrows: false,
      pagination: false,
      perPage: 4,
      gap: '60px',
      breakpoints: {
        767: {
          perPage: 2,
          gap: '61px'
        }
      }
    });

    var prevBtn = document.querySelector(SERIES_PREV_SELECTOR);
    var nextBtn = document.querySelector(SERIES_NEXT_SELECTOR);

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        slider.go('<');
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        slider.go('>');
      });
    }

    slider.mount();
  }

  document.addEventListener('DOMContentLoaded', init);
})();
